import { Button } from 'antd';
import Modal from 'antd/es/modal/Modal';
import type { ReactNode } from 'react';

import './PackageModal.scss';

type PackageModalProps = {
  children: ReactNode;
  setIsDetailModalOpen: (val: boolean) => void;
  isDetailModalOpen: boolean;
  title: ReactNode;
};

export const PackageModal = ({
  children,
  isDetailModalOpen,
  setIsDetailModalOpen,
  title,
}: PackageModalProps) => {
  return (
    <Modal
      title={title}
      centered
      open={isDetailModalOpen}
      className="package-modal-container"
      onCancel={() => setIsDetailModalOpen(false)}
      footer={[
        <Button
          size="large"
          type="ghost"
          onClick={() => setIsDetailModalOpen(false)}
        >
          Close
        </Button>,
      ]}
    >
      {children}
    </Modal>
  );
};
